var map = {
	"./cupis/coupon-ru.png": "RZmc",
	"./icon-bet.png": "Ypvh",
	"./icon-change.png": "3rGd",
	"./icon-registration.png": "3wMQ",
	"./zenbet/coupon-en.png": "Hcab",
	"./zenbet/coupon-ru.png": "evxG",
	"./zenit/coupon-en.png": "YBUD",
	"./zenit/coupon-ru.png": "MU/O"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "SRnW";